import type { TMessages } from '@/types/TMessages'

export const messages = {
  inputPlaceholder: 'Поиск',
} satisfies TMessages
